import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AdminLoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      alert('Please enter email and password');
      return;
    }

    setLoading(true);

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      if (data.session) {
        navigate('/admin/dashboard');
      }
    } catch (error: any) {
      alert(error.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#E8DDD0] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-8 shadow-md max-w-md w-full">
        <h1 className="text-4xl font-bold text-gray-900 text-center mb-3">Admin Login</h1>
        <p className="text-gray-600 text-center mb-8">Access the admin dashboard</p>

        <form onSubmit={handleLogin}>
          <label className="block text-lg font-semibold text-gray-700 mb-2 mt-4">
            Email
          </label>
          <input
            type="email"
            className="w-full border border-gray-300 rounded-lg p-3 text-lg"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />

          <label className="block text-lg font-semibold text-gray-700 mb-2 mt-4">
            Password
          </label>
          <input
            type="password"
            className="w-full border border-gray-300 rounded-lg p-3 text-lg"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#B85C38] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#A34C28] transition-colors mt-8 disabled:opacity-50"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
